"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialService = exports.SocialNetworks = void 0;
var tslib_1 = require("tslib");
var lodash_1 = tslib_1.__importDefault(require("lodash"));
var SocialNetworks;
(function (SocialNetworks) {
    SocialNetworks["FACEBOOK"] = "facebook";
    SocialNetworks["TWITTER"] = "twitter";
    SocialNetworks["LINKEDIN"] = "linkedin";
    SocialNetworks["EMAIL"] = "email";
})(SocialNetworks = exports.SocialNetworks || (exports.SocialNetworks = {}));
var socialNetworkUrlDict = (_a = {},
    _a[SocialNetworks.FACEBOOK] = 'https://www.facebook.com/sharer/sharer.php?u={shareUrl}',
    _a[SocialNetworks.TWITTER] = 'https://www.twitter.com/share?url={shareUrl}&text={shareText}',
    _a[SocialNetworks.LINKEDIN] = 'https://www.linkedin.com/shareArticle?url={shareUrl}',
    _a);
var SocialService = /** @class */ (function () {
    function SocialService() {
    }
    SocialService.prototype.prepareUrl = function (socialNetwork, shareText) {
        var url = socialNetworkUrlDict[socialNetwork];
        var compiled = lodash_1.default.template(url, { interpolate: /{([\s\S]+?)}/g });
        return compiled({
            shareUrl: window.location.href,
            shareText: shareText || '',
        });
    };
    SocialService.prototype.showSocialWindow = function (socialName, shareText) {
        var inWebView = lodash_1.default.get(window.globalSettings, 'inWebView') === true;
        if (socialName === SocialNetworks.EMAIL) {
            document.location.href = 'mailto:?subject=Share&body=' + encodeURIComponent(window.location.href);
        }
        else {
            var url = this.prepareUrl(socialName, shareText);
            window.open(url, inWebView ? "_self" : '_blank', 'width=600,height=400,resizable=yes');
        }
    };
    return SocialService;
}());
exports.SocialService = SocialService;
